import { useState } from 'react';
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { TextField, Button, IconButton } from '@tryhackme/thm-ui-components';
import { DeleteModal } from 'src/common/delete-modal';
import { StyledImageChangeGridContainer, StyledLabel, StyledMachineUrl, StyledQuestion, StyledRemoveButton, StyledTask, StyledNodeImageRow, StyledImageChangeContainer } from 'src/features/admin/networks/components/node-images/node-images.styles';
import { useFormContext, useFieldArray } from 'src/common/form';
import { StyledNodeImageContainer, StyledNodeImageData, StyledNodeImageHeader, StyledFontAwesomeIcon, StyledNodeImageButtonWrapper, StyledFontAwesomePlusIcon } from '../../networks.styles';
import { NodeImagesProps } from '../../networks.types';
export const NodeImages = ({
  nestIndex
}: NodeImagesProps) => {
  const {
    control,
    register
  } = useFormContext();
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: `nodes.${nestIndex}.change`
  });
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  return <>
      <StyledNodeImageContainer data-testid="node-images" data-sentry-element="StyledNodeImageContainer" data-sentry-source-file="node-images.tsx">
        {fields?.map((item, k) => <StyledNodeImageRow key={item.id} data-testid="image-row">
            <StyledImageChangeContainer>
              <StyledNodeImageData>
                <StyledNodeImageHeader>Image change</StyledNodeImageHeader>

                <StyledImageChangeGridContainer>
                  <StyledTask>
                    <TextField {...register(`nodes.${nestIndex}.change.${k}.taskNo`)} id={`nodes.${nestIndex}.change.${k}.taskNo`} placeholder="1" variant="input" label="Task" />
                  </StyledTask>
                  <StyledQuestion>
                    <TextField {...register(`nodes.${nestIndex}.change.${k}.questionNo`)} id={`nodes.${nestIndex}.change.${k}.questionNo`} placeholder="1" variant="input" label="Question" />
                  </StyledQuestion>
                  <StyledMachineUrl>
                    <TextField {...register(`nodes.${nestIndex}.change.${k}.image`)} id={`nodes.${nestIndex}.change.${k}.image`} placeholder="/img/network/windows2016_infected.png" variant="input" label="Machine image URL" />
                  </StyledMachineUrl>
                  <StyledLabel>
                    <TextField {...register(`nodes.${nestIndex}.change.${k}.label`)} placeholder="Throwback-PROD\n10.200.2.219" variant="input" label="Label" id={`nodes.${nestIndex}.change.${k}.label`} />
                  </StyledLabel>
                </StyledImageChangeGridContainer>
              </StyledNodeImageData>
              <StyledRemoveButton>
                <IconButton variant="delete" width="3.6rem" height="3.6rem" aria-label="Delete image change" onClick={() => {
              setActiveIndex(nestIndex);
              setDeleteModalOpen(true);
            }}>
                  <StyledFontAwesomeIcon icon={faTrashCan} />
                </IconButton>
              </StyledRemoveButton>
            </StyledImageChangeContainer>
          </StyledNodeImageRow>)}
      </StyledNodeImageContainer>
      <StyledNodeImageButtonWrapper data-sentry-element="StyledNodeImageButtonWrapper" data-sentry-source-file="node-images.tsx">
        <Button variant="outlined" color="secondary" onClick={() => append({
        active: true,
        taskNo: 0,
        questionNo: 0,
        correct: true,
        image: '',
        label: ''
      })} data-sentry-element="Button" data-sentry-source-file="node-images.tsx">
          <StyledFontAwesomePlusIcon icon={faPlus} data-sentry-element="StyledFontAwesomePlusIcon" data-sentry-source-file="node-images.tsx" />
          Add Image Change
        </Button>
      </StyledNodeImageButtonWrapper>
      <DeleteModal open={deleteModalOpen} onOpenChange={setDeleteModalOpen} modalTitleText="Delete Image Change" modalBodyText="Are you sure you want to delete this image change?" activeIndex={activeIndex} handleDeleteAction={(activeInd: number) => remove(activeInd)} data-sentry-element="DeleteModal" data-sentry-source-file="node-images.tsx" />
    </>;
};